/* RESPONSIBLE TEAM: team-knowledge-foundations */
import { attr } from '@ember-data/model';
import { fragment } from 'ember-data-model-fragments/attributes';
import Fragment from 'ember-data-model-fragments/fragment';

export interface ImportConfig {
  metadata_fields?: string[];
  auto_enable_fin?: boolean;
  auto_enable_copilot?: boolean;
  set_live_auto?: boolean;
  custom_name?: string;
}

export default class ImportSourceContext extends Fragment {
  @attr('boolean') declare unauthorized: boolean;
  // Guru context
  @attr('string') declare collectionId?: string;
  @attr('string') declare collectionName?: string;

  // Confluence context
  @attr('string') declare siteId: string;
  @attr('string') declare spaceId: string;
  @attr('string') declare spaceName: string;
  @attr('array', { defaultValue: () => [] }) declare deny_folder_ids: string[];
  @attr('string') declare base_url: string;
  @attr('boolean') declare use_v2: boolean;

  // Notion context
  @attr('string') declare workspaceName: string;

  // box context
  @attr('array') declare file_types: string[];
  @attr('array') declare selectedItems: string[];

  //general context
  @attr('array') declare metadata: any;
  @attr('array') declare entityMetadata: any;
  @attr('boolean') declare manually_paused: boolean;

  // Import configuration - namespaced config for import settings
  @attr() declare import_config: ImportConfig;

  // Document360 context
  @attr('string') declare hostingRegion: string;
  @attr('string') declare projectId: string;
  @attr('array') declare languageCodes: string[];
  @attr('string') declare projectName: string;
  @attr('array') declare selectedCategoryIds: string[];

  // Salesforce knowledge context
  @attr('array') declare predicates: any[];
  @fragment('predicates/predicate-group') declare predicate_group: any;
  @attr() declare mappings: Record<string, any>;
  @attr() declare data_category_filter: any;

  // Freshdesk context
  @attr('string') declare domain: string;

  // Shopify context
  @attr('string') declare shopify_shop_id: string;
}
